import { Form, Input, Button, FormInstance, Row, Col } from 'antd'
import React, { Component } from 'react';

const FormItem = Form.Item;
interface FormProps {
    onCreate: Function
    sendCaptcha: Function
}

class EditForm extends Component<FormProps> {

    formRelf;
    constructor(props) {
        super(props);
        this.formRelf = React.createRef<FormInstance>();
    }

    state = {
        count: 0
    }

    onFinish = (values) => {
        // e.preventDefault();
        const { onCreate } = this.props;
        let username = localStorage.getItem('username');
        values.phone = username;
        onCreate(values);
    }

    intId;
    sendCaptcha = () => {
        const { sendCaptcha } = this.props;
        let username = localStorage.getItem('username');
        sendCaptcha(username);

        this.setState({
            count: 60
        });
        let that  = this;
        that.intId = setInterval(() => {
            let count = that.state.count;
            // console.log(count);
            if(count === 0) {
                window.clearInterval(that.intId);
                that.intId = 0;
            }
            else {
                that.setState({
                    count: count - 1
                });
            }
        }, 1000);
       
    }

    componentWillUnmount () {
        if(this.intId) window.clearInterval(this.intId)
    }

    render () {

        let username = localStorage.getItem('username');

        return (
            <Form 
                layout='vertical' 
                onFinish={this.onFinish} 
                autoComplete="off"
                initialValues={{
                    mobileNumber: username,
                }}
                ref={this.formRelf}
                >
                <FormItem 
                    label='账号' 
                    name="mobileNumber"
                    rules={[{required: true, message: '请输入账号', whitespace: true}]}
                    >
                    <Input disabled/>
                </FormItem>
                
                <Row className="flex-center">
                    <Col span={16}>
                        <FormItem 
                            label='验证码'
                            name="captcha"
                            rules={[{required: true, message: '请输入验证码'}]}>
                            <Input placeholder='请输入验证码'/>
                        </FormItem>
                    </Col>
                    <Col span={6} className="btn-captcha">
                        {
                            this.state.count === 0 ?
                            <Button onClick={this.sendCaptcha}>获取验证码</Button>
                            :
                            <Button disabled>{this.state.count}s</Button>
                        }
                    </Col>
                </Row>
                <FormItem 
                    label='新密码' 
                    name="newPassword"
                    rules={[{required: true, message: '请输入新密码', whitespace: true}]}
                    >
                    <Input.Password type="password" placeholder='请输入新密码' autoComplete='new-password'/>
                </FormItem>
                <Button 
                    type="primary" 
                    htmlType="submit" 
                    className="save">保存</Button>
            </Form>
        )
    }
}

export default EditForm